import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { IrisIconComponent, IconSizes } from '@sondermind/iris/icon';

interface BannerMetric {
  icon: string;
  value?: string;
  label: SafeHtml;
}

export type BannerVariant = 'control' | 'ratings-and-recommendations' | 'insurance-and-accessibility' | 'off';

@Component({
  selector: 'landing-page-banner',
  standalone: true,
  imports: [
    CommonModule,
    IrisIconComponent
  ],
  templateUrl: './landing-page-banner.component.html',
  styleUrls: ['./landing-page-banner.component.scss']
})
export class LandingPageBannerComponent {
  readonly variant = input<BannerVariant>();
  readonly iconSizes = IconSizes;

  constructor(private domSanitizer: DomSanitizer) {}

  readonly metrics = computed<BannerMetric[]>(() => {
    if (this.variant() === 'insurance-and-accessibility') {
      return [
        {
          icon: 'verified_user_outline',
          label: this.domSanitizer.bypassSecurityTrustHtml('Accepts hundreds of insurances')
        },
        {
          icon: 'acute_outline',
          label: this.domSanitizer.bypassSecurityTrustHtml('Start care in <strong>2 days</strong>')
        },
        {
          icon: 'dollar',
          label: this.domSanitizer.bypassSecurityTrustHtml('<strong>$25</strong> average copay')
        }
      ];
    }

    return [
      {
        icon: 'star_outline',
        value: '4.4/5',
        label: this.domSanitizer.bypassSecurityTrustHtml('Trustpilot rating')
      },
      {
        icon: 'smile_outline',
        value: '4.7/5',
        label: this.domSanitizer.bypassSecurityTrustHtml('client satisfaction')
      },
      {
        icon: 'thumb_up_outline',
        value: '8.8/10',
        label: this.domSanitizer.bypassSecurityTrustHtml('would recommend')
      }
    ];
  });
}
